module.exports = __webpack_public_path__ + "static/15-img-2-b57ad638b3bb5c9b145c2326f80c8041.png";